module.exports = __webpack_public_path__ + "img/may-month.03714f04.png";